import {
  PurchaseFreightBookingRequestSchema,
  PurchaseFreightBookingResponseSchema,
} from "@redotech/redo-model/freight/freight-booking";

export const purchaseFreightBooking = {
  name: "purchaseFreightBooking" as const,
  input: PurchaseFreightBookingRequestSchema,
  output: PurchaseFreightBookingResponseSchema,
};
